import { createFileRoute } from '@tanstack/react-router';
import { BillingHistoryPage } from '@/components/BillingHistoryPage';

export const Route = createFileRoute('/_authenticated/billing/history')({
  component: BillingHistoryPage,
});
